











































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ParamsFilter from '@/components/common/ParamsFilter.vue'
import { getJson } from '@/request/apis/common'

@Component({
  components: {
    ParamsFilter
  }
})
export default class ParamsDialogWrapper extends Vue {
  @Ref('paramsFilter') readonly paramsFilter!: ParamsFilter
  @Prop() chooseData!: string
  @Prop({ default: 'data' }) type!: string // data-数据筛选, param-参数选择

  private dialogVisible: boolean = false
  private jsonFile: object = {}
  private filterName: string = ''
  private reset: number = 0

  /**
   * 获取数据的json内容来过滤参数
   */
  private async getFilterJson () {
    this.jsonFile = await getJson(null, this.chooseData).start()
    this.filterName = this.chooseData + '_filter'
    this.dialogVisible = true
  }

  /**
   * 保存筛选后的参数
   */
  private async saveFilterParams () {
    try {
      const params = this.paramsFilter.getSearchCriteria()
      this.$emit('filter', new CustomEvent('filter', {
        detail: {
          params: params,
          filterName: Object.keys(params).length > 0 ? this.filterName : this.chooseData
        }
      }))
      this.dialogVisible = false
    } catch (e) {
      console.log(e)
    }
  }
}
